export default function printDiv(divName) {
    let printContents = document.getElementById(divName);
    let searchelement = printContents.getElementsByClassName("sr-only");
    if (searchelement && searchelement[0]?.parentNode) {
      searchelement[0].parentNode.removeChild(searchelement[0]);
    }
    var winPrint = window.open(
      "",
      "",
      "left=0,top=0,toolbar=0,scrollbars=0,status=0"
    );
    // winPrint.document.body.innerHTML = printContents;
    // <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css">
    winPrint.document.write(
      `<title>${divName} Report</title>
      <head>
        <style>
          @page {
        margin: 4mm;
      }
      
      body {
        margin: 4mm;
      } 
         /* Hide react-bootstrap-table controls */
           .sr-only,
      .react-bootstrap-table-pagination,
      .react-bootstrap-table-filter-wrapper,
      .search-label,
      .select-filter,
      .custom-select,
      [class*="toolbar"],
      .react-bootstrap-table-pagination-list,
      .react-bootstrap-table-pagination-total,
      .text-filter,
      .text-filter-column,
      .filter-label,
      [class*="filter"],
      .react-bootstrap-table-search,
      .react-bootstrap-table-search-input {
        display: none !important;
      }
          
          /* Hide search box */
          .react-bootstrap-table-search-input,
          .react-bootstrap-table-search,
          .search-bar {
            display: none !important;
          }
          
          /* Remove extra padding/margins from table */
          .react-bootstrap-table {
            margin: 0 !important;
            padding: 0 !important;
          }
          
           .quantities-column {
        min-width: 150px !important;
      }
        .items_name {
         max-width: 150px !important;
        }
            .price-details {
              min-width: 150px
            }
          /* Ensure table takes full width */
          .table-responsive {
            width: 100% !important;
            margin: 0 !important;
            padding: 0 !important;
          }
          table {
            table-layout: fixed;
            font-family: "Poppins", sans-serif;
            border: 1px solid #eff2f7;
            font-size: 12px;
            border-collapse: collapse;
            max-width: 100%;
            color: #495057;
        
          
            margin-bottom: 1rem;
            margin-top: 1rem;
          }
          
          .d-print-none {
 
    display: none !important;
 
}
          for-print-heading {
            font-size: 16px;
            margin: 0 0 7px 0;
            font-weight: bold;
          }

          for-print-sub_heading {
            font-size: 14px;
            margin: 0 0 7px 0;
            font-weight: normal !important;
          }

          table td, table th {
            border: 1px solid #ddd;
            padding: 8px;
          }
          
          table tr:nth-child(even){background-color: #f2f2f2;}
          
          table tr:hover {background-color: #ddd;}
          
          table th {            
            text-align: left;
          }
        </style>
      </head>
      <body>
        ${printContents.innerHTML}
      </body>
      `
    );
    winPrint.document.close();
    winPrint.focus();
    winPrint.print();
    //winPrint.close();
  }